export const TERMINATE_TASK_SUCCESS = 'TERMINATE_TASK_SUCCESS' as const;
export const TERMINATE_TASK_ERROR = 'TERMINATE_TASK_ERROR' as const;
export const LOG = 'LOG' as const;

export type WorkerCallBackActions = 'TERMINATE_TASK_SUCCESS' | 'TERMINATE_TASK_ERROR' | 'LOG';
